import React from "react";
import "./VirasatV2DefaultHomePage.scss"
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";




const VirasatV2DefaultServicesPage = ({ components }) => {
    const dispatch = useDispatch()
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-subheader":
                return <div className="VirasatV2DefaultServicesPage-header-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultServicesPage-headertext":
                return <div className="VirasatV2DefaultServicesPage-header-title">{component?.Props?.header}
                    <div className="VirasatV2DefaultServicesPage-header-title-hl"> {component?.Props?.highlightedHeader}</div></div>
            default:
                return <div />
        }

    }
    const headerContent = (headerComponent) => {
        return (
            <div
                className="VirasatV2DefaultServicesPage-header"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #192233 29.22%, rgba(82, 69, 69, 0) 169.9%), url(${headerComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={headerComponent?.Props?.leftSrc} className="VirasatV2DefaultServicesPage-header-indimg" />
                {sortByOrderAscending(headerComponent?.Components).map((component, key) => {
                    return (
                        getHeaderComponents(component)
                    )
                })}
                <img alt="" src={headerComponent?.Props?.rightSrc} className="VirasatV2DefaultServicesPage-header-vegimg" />

            </div>
        )
    }
    const getBottomComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-bottom-subheader":
                return <div className="VirasatV2DefaultServicesPage-bottom-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultServicesPage-bottom-headertext":
                return <div className="VirasatV2DefaultServicesPage-bottom-title">{component?.Props?.text}</div>
            case "VirasatDefaultServicesPage-bottom-btncont":
                return <div className="VirasatV2DefaultServicesPage-bottom-btncont">
                    {component?.Components?.map((button, key) => {
                        return (
                            <Button
                                text={button?.Props?.text}
                                width={button?.Props?.width}
                                isBorder={button?.Props?.isBorder}
                                key={key}
                                onClick={() => {
                                    if (button?.Props?.href && button?.Props?.href !== "") {
                                        if (button?.Props?.href?.includes("https://")) {
                                            window.open(button?.Props?.href, '_blank')
                                        } else {
                                            window.location.href = button?.Props?.href && button?.Props?.href !== "" ? button?.Props?.href : "/"
                                        }
                                    }
                                    else {
                                        dispatch(setIsComing(true))
                                    }
                                }} />
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    const bottomContent = (bottomComponent) => {
        return (
            <div
                className="VirasatV2DefaultServicesPage-bottom"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #040508 29.22%, rgba(82, 69, 69, 0) 95.57%)
, url(${bottomComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={bottomComponent?.Props?.leftSrc} className="VirasatV2DefaultServicesPage-bottom-indimg" />
                {sortByOrderAscending(bottomComponent?.Components).map((component, key) => {
                    return (
                        getBottomComponents(component)
                    )
                })}
                <img alt="" src={bottomComponent?.Props?.rightSrc} className="VirasatV2DefaultServicesPage-bottom-vegimg" />

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-header":
                return headerContent(component)
            case "VirasatDefaultServicesPage-container":
                return <div className="VirasatV2DefaultServicesPage-container"
                    style={{ gridTemplateColumns: component?.Data.length < 3 ? `repeat(2, calc((100% - 30px) / 2))` : " repeat(3, calc((100% - 60px) / 3))" }}>
                    {component?.Data.map((service, key) => {
                        return (
                            <ServiceCard service={service} key={key} />
                        )
                    })

                    }
                </div>
            case "VirasatDefaultServicesPage-bottom":
                return bottomContent(component)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2DefaultServicesPage"
        >
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )

}
export default VirasatV2DefaultServicesPage